import {InstrumentAnnotationBlock} from "./InstrumentAnnotationBlock.js";

export class InstrumentTrack {
    constructor(jsonStructure) {
        this.track_id = jsonStructure.track_id;
        this.name = jsonStructure.name;
        this.instrument = jsonStructure.instrument;
        this.is_main_melody = Boolean(jsonStructure.is_main_melody);
        this.marked_for_deletion = Boolean(jsonStructure.marked_for_deletion);
        this.colorType = jsonStructure.colorType;
        this.annotation_blocks = [];
        for (const annotationBlock of jsonStructure.annotation_blocks) {
            this.annotation_blocks.push(new InstrumentAnnotationBlock(annotationBlock));
        }
    }
}
